import React from "react"
import Cabecalho from "../Cabecalho"
import { IntegracaoFoodyDeliveryForm } from "./components/IntegracaoFoodyDeliveryForm"

export function IntegracaoFoodyDelivery() {
    return (
        <>
            <Cabecalho pagina="Integração Foody Delivery" />
            <IntegracaoFoodyDeliveryForm />
        </>
    )
}
